import { render, staticRenderFns } from "./BillGiftProductModal.vue?vue&type=template&id=52ef2952&scoped=true"
import script from "./BillGiftProductModal.vue?vue&type=script&lang=js"
export * from "./BillGiftProductModal.vue?vue&type=script&lang=js"
import style0 from "./BillGiftProductModal.vue?vue&type=style&index=0&id=52ef2952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ef2952",
  null
  
)

export default component.exports